import React from "react";
import { ProductConsumer } from "../../Context/AddProWakel";
import { imageSrc } from "../../util/PublicOrderAPI";

const matchesSearch = (category, term) => {
    if (!term) return true;
    const needle = term.toLowerCase();
    return category.name && String(category.name).toLowerCase().includes(needle);
};

// Small thumbnail — categories carry a free-form image URL (may be empty).
const CatThumb = ({ image, name }) => {
    if (!image) {
        return (
            <span className="rs-thumb rs-thumb--empty">
                <i className="fas fa-tag"></i>
            </span>
        );
    }
    return <img className="rs-thumb" src={imageSrc(image)} alt={name || ""} />;
};

class ScroollTableCategory extends React.Component {
    render() {
        return (
            <ProductConsumer>
                {(value) => {
                    const {
                        CT_categories,
                        CT_search,
                        CT_OpenEdit,
                        CT_toggleActive,
                        CT_deleteCategory
                    } = value;

                    // Show in sortOrder order (the admin list isn't pre-sorted).
                    const list = CT_categories
                        .filter((c) => matchesSearch(c, CT_search))
                        .slice()
                        .sort((a, b) => (a.sortOrder || 0) - (b.sortOrder || 0));

                    return (
                        <div className="rs-card">
                            <div className="rs-table-wrap">
                                <table className="rs-table">
                                    <thead>
                                        <tr>
                                            <th style={{ width: "64px" }}>رەسم</th>
                                            <th>ناو</th>
                                            <th className="is-center" style={{ width: "120px" }}>
                                                ژمارەی کاڵا
                                            </th>
                                            <th className="is-center" style={{ width: "100px" }}>
                                                ڕیزبەندی
                                            </th>
                                            <th className="is-center" style={{ width: "120px" }}>
                                                دۆخ
                                            </th>
                                            <th className="is-center" style={{ width: "230px" }}>
                                                کردار
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {list.map((category, i) => {
                                            const active = category.isActive !== false;
                                            return (
                                                <tr key={category.id || i}>
                                                    <td>
                                                        <CatThumb
                                                            image={category.image}
                                                            name={category.name}
                                                        />
                                                    </td>
                                                    <td className="rs-strong">
                                                        {category.name || "—"}
                                                    </td>
                                                    <td className="is-center rs-num">
                                                        {category.productCount || 0}
                                                    </td>
                                                    <td className="is-center rs-num">
                                                        {category.sortOrder || 0}
                                                    </td>
                                                    <td className="is-center">
                                                        <span
                                                            className={`rs-badge ${active ? "rs-badge--green" : "rs-badge--grey"
                                                                }`}
                                                        >
                                                            <i
                                                                className={`fas ${active ? "fa-check-circle" : "fa-eye-slash"
                                                                    }`}
                                                            ></i>
                                                            {active ? "چالاک" : "ناچالاک"}
                                                        </span>
                                                    </td>
                                                    <td className="is-center">
                                                        <button
                                                            className="rs-btn rs-btn--ghost rs-btn--sm"
                                                            onClick={() => CT_OpenEdit(category)}
                                                            title="دەستکاری"
                                                        >
                                                            <i className="fas fa-edit"></i>
                                                            دەستکاری
                                                        </button>{" "}
                                                        <button
                                                            className={`rs-btn rs-btn--sm ${active ? "rs-btn--ghost" : "rs-btn--green"
                                                                }`}
                                                            onClick={() => CT_toggleActive(category)}
                                                            title={active ? "ناچالاککردن" : "چالاککردن"}
                                                        >
                                                            <i
                                                                className={`fas ${active ? "fa-eye-slash" : "fa-check"
                                                                    }`}
                                                            ></i>
                                                            {active ? "شاردنەوە" : "چالاک"}
                                                        </button>{" "}
                                                        <button
                                                            className="rs-btn rs-btn--danger rs-btn--sm"
                                                            onClick={() => CT_deleteCategory(category)}
                                                            title="سڕینەوە"
                                                        >
                                                            <i className="fas fa-trash"></i>
                                                        </button>
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </div>

                            {list.length === 0 && (
                                <div className="rs-empty">
                                    <i className="fas fa-inbox"></i>
                                    <p>هیچ جۆرێک نەدۆزرایەوە</p>
                                </div>
                            )}
                        </div>
                    );
                }}
            </ProductConsumer>
        );
    }
}

export default ScroollTableCategory;
